
<template>
  <v-footer v-if="usuarioLogado" color="white" width="auto" style="justify-content: center; border-top: 1px solid #e3e7e7;">
    <p class="textofooter" style="margin: 0px">COPYRIGHT © {{ new Date().getFullYear() }} - NPS {{ configuracoes.nomeParceiro }}</p>
    <!-- <span><img  class="imagemLogoFooter" src="../assets/logo-mini.png" alt="" height="30" width="auto"></span> -->
    <v-spacer></v-spacer>
    <v-btn icon>
      <img src="../assets/facebook.png">
    </v-btn>
    <v-btn icon>
      <img src="../assets/instagram.png">
    </v-btn>
  </v-footer>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        configuracoes: {},
      }
    },

    created: async function () {
      await this.configuracoesGerais()
    },

    mounted: function () {
      if (sessionStorage.getItem('accToken') != null)
        this.$store.dispatch('Logar', this.token)
    },

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      username: state => state.UserName
    }),

    methods: {
      async configuracoesGerais() {
        await axios.get(baseApiUrl + 'Configuracoes/info')
        .then(response => {
          if (response.data) {
            this.configuracoes = response.data
          }
        })
      }
    } 
  }
</script>

<style>
  .textofooter {
    font-size: 11px;
    position: absolute;
    color: #5f6b6b;
    /* right: 42%; */
    /* left:42%; */
    margin-right: -50px;
    margin-left: -50px;
  }

  .imagemLogoFooter {
    margin-left:45px;
    left:5%;
  }
</style>
